import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { gallery } from "@/mocks/testimonials";

export default function JudgeWall() {
  return (
    <section className="bg-secondary-950 py-14 md:py-20">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:items-center">
          <div className="lg:col-span-5">
            <p className="mb-2 flex items-center gap-2 text-xs font-medium uppercase tracking-[0.28em] text-accent-400">
              <span className="inline-block h-px w-6 bg-accent-500" />
              Judge Wall
            </p>
            <h2 className="font-heading text-2xl font-bold text-background-50 md:text-3xl">
              评委表情墙
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-background-300 md:text-base">
              镜头扫过评委席的那几秒，信息量常常比整场比赛还大。低头写字、盯着水杯、交换眼神、肩膀微抖——我们把这些被反复慢放的瞬间单独收进一面墙。
            </p>
            <p className="mt-4 text-sm leading-relaxed text-background-400">
              需要说明的是，评委的职业素养不允许他们当场评价，身体反应比嘴快并不代表失职。围观的重点是那份共同的尴尬，而不是替谁定罪。
            </p>
            <Link
              to="/category/judge"
              className="mt-7 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-3 text-sm font-medium text-foreground-950 transition-colors hover:bg-accent-400"
            >
              <span className="inline-flex h-4 w-4 items-center justify-center">
                <i className="ri-user-star-line" />
              </span>
              进入评委表情栏目
            </Link>
          </div>

          <div className="grid grid-cols-2 gap-3 lg:col-span-7 lg:gap-4">
            {gallery.map((item) => (
              <figure
                key={item.src}
                className="group relative aspect-square w-full overflow-hidden rounded-lg"
              >
                <img
                  src={item.src}
                  alt={item.alt}
                  className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
                />
                <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/85 to-transparent p-3 text-xs text-background-100">
                  {item.alt}
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}